import React from 'react';
import { useLocation } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import AddUser from '../../components/usermanagement_comp/AddUser';

/**
 * AddUserPage — Page wrapper for Add/Edit User module
 * Title switches between "Add User" and "Edit User"
 * based on whether location.state contains a user record.
 */
const AddUserPage = () => {
    const { state } = useLocation();

    // Prefer MongoDB _id; fall back to userId string, then plain id (sample data)
    const isEditMode = !!(state?._id ?? state?.userId ?? state?.id ?? null);
    const pageTitle = isEditMode ? 'Edit User' : 'Add User';

    return (
        <div className="d-flex flex-column h-100 overflow-hidden py-2 py-md-3 px-0 px-md-5">
            <div className="flex-shrink-0">
                <PageHeader title={pageTitle} />
            </div>
            <div className="flex-grow-1 overflow-auto d-flex flex-column">
                <AddUser />
            </div>
        </div>
    );
};

export default AddUserPage;
